import { MineralType } from 'types/minerals';
import styles from './config-skeleton.module.scss';
import { SkeletonPlaceholder } from '@carbon/react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from 'components/accordion/accordion';
import { useState } from 'react';
import { capitalize } from 'lodash-es';

interface ConfigSkeletonProps {
  id: string;
  hideButtons?: boolean;
  className?: string;
}

export const ConfigSkeleton = ({
  id,
  hideButtons = false,
  className,
}: ConfigSkeletonProps) => {
  return (
    <div id={id} className={className}>
      <div className={styles.inputsContainer}>
        {Array.from({ length: 7 }).map((_, index) => (
          <SkeletonPlaceholder key={index} className={styles.inputSkeleton} />
        ))}
      </div>

      {!hideButtons && (
        <div className={styles.buttonsContainer}>
          <SkeletonPlaceholder className={styles.buttonSkeleton} />
        </div>
      )}
    </div>
  );
};

export const ProductionStreamConfigSkeleton = ({
  stream,
}: {
  stream: MineralType;
}) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <Accordion expanded={expanded} onClick={() => setExpanded((prev) => !prev)}>
      <AccordionSummary>
        <h2 className={styles.configFormTitle}>
          {capitalize(stream)} Model Config
        </h2>
      </AccordionSummary>
      <AccordionDetails>
        <div className={styles.configFormContainer}>
          <div className={styles.actionContainer}>
            <SkeletonPlaceholder className={styles.selectSkeleton} />
            <SkeletonPlaceholder className={styles.buttonSkeleton} />
            <SkeletonPlaceholder className={styles.buttonSkeleton} />
          </div>

          <div className={styles.modelTypeContainer}>
            <SkeletonPlaceholder className={styles.modelTypeSkeleton} />
            <SkeletonPlaceholder className={styles.modelTypeSkeleton} />
            <SkeletonPlaceholder className={styles.modelTypeSkeleton} />
          </div>

          <div className={styles.buttonsContainer}>
            <SkeletonPlaceholder className={styles.buttonSkeleton} />
            <SkeletonPlaceholder className={styles.buttonSkeleton} />
            <SkeletonPlaceholder className={styles.buttonSkeleton} />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};
